<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2 text-center" >
			
			  
			  <div class="text-white">
			      
			      <el-date-picker
			        v-model="start"
			        type="date"
			        placeholder="開始日期">
			      </el-date-picker>
			    </div>
				
				<div class="text-white mt-2">
				    
				    <el-date-picker
				      v-model="end"
				      type="date"
				      placeholder="結束日期">
				    </el-date-picker>
				  </div>
			  
			  
			 <!-- <el-input v-model="input" placeholder="安全密碼" show-password></el-input>
			  -->
			  <el-button type="danger" @click="clearConfirm" class="mt-5" icon="el-icon-delete" plain>清理數据</el-button>
		</div>


	
		
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {},
				
			
				start:'',
				end:'',
				model_title: '',
				auth_val: '',
				preUrl: "", //列表地址
				addUrl: "", //添加/修改地址
				editStatusUrl: "", //修改狀態地址
			
				prop: 'create_time',
				sort: 'descending',
				
			}
		},
		watch: {
			
		},
		created() {
			//this.commonList('pnumList');
		},
		methods: {
			clearConfirm(){
				if(!this.start || !this.end){
					this.$message({
						message: '請先選擇日期',
						type: 'error'
					});
					
					return false
				}
				this.$confirm('確定要清除數据，清除後數据不可恢复, 是否继续?', '提示', {
					  confirmButtonText: '確定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					  
					  this.clearDataApi()
					}).catch(() => {
					       
					});
			},
			
			clearDataApi(){
					this.axios.post('/admin/data/clearDataApi',
						{start:this.start,end:this.end}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						
						if (all.code == 1) {
							this.$message({
								message: all.msg,
								type: 'success'
							});
							
						}

					}).catch(err => {
						// 失敗
						
					})
				
			},
			
		
		
			
		
			

			// 打开模态框
			openModel(e, type) {
				
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				
			},
			getListResult(e) {
				
			},
		
		}
	}
</script>

<style>
</style>
